var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-table-simple",
        {
          ref: "detailGrid",
          attrs: { bordered: "", responsive: "", "sticky-header": "" },
        },
        [
          _c("colgroup", [
            _c("col", { staticStyle: { width: "150px" } }),
            _c("col", { staticStyle: { width: "100px" } }),
            _c("col", { staticStyle: { width: "100px" } }),
            _c("col", { staticStyle: { width: "100px" } }),
            _c("col", { staticStyle: { width: "100px" } }),
          ]),
          _c(
            "b-thead",
            { attrs: { "head-variant": "light" } },
            [
              _c(
                "b-tr",
                [
                  _c("b-th", { staticClass: "sticky-header" }, [
                    _vm._v(" 계약명 "),
                  ]),
                  _c("b-th", { staticClass: "sticky-header" }, [
                    _vm._v(" 상세 코드 "),
                  ]),
                  _c("b-th", [_vm._v(" 해당 코드가 등록된 요양기관 수 ")]),
                  _c("b-th", [_vm._v(" 일일 팝업 노출 수 ")]),
                  _c("b-th", [_vm._v(" 데스크인포 버튼 클릭 수 ")]),
                ],
                1
              ),
            ],
            1
          ),
          _vm.data
            ? _c(
                "b-tbody",
                [
                  _vm._l(_vm.data, function (member, index) {
                    return [
                      _c(
                        "b-tr",
                        { key: "member-" + member.contractId + "-" + index },
                        [
                          member.rowCount > 0
                            ? _c(
                                "b-td",
                                {
                                  staticStyle: { left: "0" },
                                  attrs: {
                                    rowspan: member.rowCount,
                                    "contract-id": "",
                                  },
                                },
                                [_vm._v(_vm._s(member.contractName))]
                              )
                            : _vm._e(),
                          _c("b-td", [_vm._v(_vm._s(member.entryCode))]),
                          _c("b-td", [
                            _vm._v(
                              _vm._s(
                                _vm._f("$numberFormatter")(
                                  member.hcpWorkPlaceCount
                                )
                              )
                            ),
                          ]),
                          _c("b-td", [
                            _vm._v(
                              _vm._s(
                                _vm._f("$numberFormatter")(
                                  member.dailyPopupCount
                                )
                              )
                            ),
                          ]),
                          _c("b-td", [
                            _vm._v(
                              _vm._s(
                                _vm._f("$numberFormatter")(
                                  member.buttonPopupCount
                                )
                              )
                            ),
                          ]),
                        ],
                        1
                      ),
                    ]
                  }),
                ],
                2
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }